export default __webpack_public_path__ + "static/media/14.6da56dfa.jpg";